import React from 'react';
import PropTypes from 'prop-types';
import {Empty} from './Empty';
import {Wrapper} from './Wrapper';
import {Feedback} from '../Feedback';
import {RectangleCard} from '@learningblocks/storybook-components';
import {Utilities} from '@learningblocks/exp-constants';
const {
  COMPONENT_TYPE,
  DRAG_DROP_DATA,
  DRAG_DROP__ID,
  DRAG_DROP__TYPE,
} = Utilities;
import './style.scss';

export function Technique(props) {
  const onSelect = (e) => props.onSelect && props.onSelect(e);

  const onRemove = () => !props.isCorrect && props.onRemove && props.onRemove();
  const option = () => (
    <Wrapper className='design-view__techniqueCompOption'>
      <RectangleCard
        className='design-view__techniqueCompOption--item'
        tabIndex={props.tabIndex}
        title={props.title}
        image={props.image}
        onSelect={onSelect}
        addCard={props.onSelect}
        description={props.description}
        glossaryId={props.glossaryId}
      />
    </Wrapper>
  );

  const mobileViewOption = () => (
    <Wrapper className='design-view__techniqueCompOption'>
      <RectangleCard
        className='design-view__techniqueCompOption--item'
        title={props.title}
        image={props.image}
        onSelect={onSelect}
        description={props.description}
        isMobileOption={true}
        glossaryId={props.glossaryId}
      />
    </Wrapper>
  );

  const stepCorrect = () => (
    <Wrapper className='design-view__techniqueComp'>
      <RectangleCard
        tabIndex={props.tabIndex}
        title={props.title}
        image={props.image}
        addCard={props.onSelect}
        description={props.description}
        glossaryId={props.glossaryId}
        // trim={false}
      />
      <Feedback.Wrap
        onSelect={onRemove}
        tabIndex={-1}
        className='design-view__techniqueComp_feedback'>
        <Feedback.IconCorrect className='design-view__techniqueComp_feedback--icon' />
      </Feedback.Wrap>
    </Wrapper>
  );

  const stepIncorrect = () => (
    <Wrapper className='design-view__techniqueComp'>
      <RectangleCard
        tabIndex={props.tabIndex}
        title={props.title}
        image={props.image}
        addCard={props.onSelect}
        description={props.description}
        glossaryId={props.glossaryId}
        // trim={false}
      />
      <Feedback.Wrap
        onSelect={onRemove}
        tabIndex={props.tabIndex}
        className='design-view__techniqueComp_feedback'>
        <Feedback.IconIncorrect
          className='design-view__techniqueComp_feedback--icon'
          show={props.showTooltip}
          message={props.feedbackMessage}
        />
      </Feedback.Wrap>
    </Wrapper>
  );

  const onDrop = React.useCallback((event) => {
    const dropData = JSON.parse(event.dataTransfer.getData(DRAG_DROP_DATA));
    const optionId = dropData[DRAG_DROP__ID];
    const componentType = dropData[DRAG_DROP__TYPE];
    props.onDrop({optionId, componentType});
  }, []);

  const onAddStep = (params) => {
    props.onDrop({...params, componentType: COMPONENT_TYPE.TECHNIQUE_CARD});
  };

  const emptyStep = () => (
    <Wrapper
      className='design-view__techniqueComp'
      onDrop={onDrop}>
      <Empty
        className='empty-technique'
        text={props.placeHolder}
        options={props.optionsList}
        onAddStep={onAddStep}
      />
    </Wrapper>
  );

  if (props.onSelect) {
    return option();
  } else {
    if (props.isEmpty) {
      return emptyStep();
    } else {
      if (props.isCorrect) {
        return stepCorrect();
      } else if (props.isCorrect === false) {
        return stepIncorrect();
      } else {
        return mobileViewOption();
      }
    }
  }
}

Technique.propTypes = {
  /**
   * tabIndex to set element and children
   */
  tabIndex: PropTypes.number,
  /**
   * Title to display on Technique
   */
  title: PropTypes.string,
  /**
   * Description of technique
   */
  description: PropTypes.string,
  /**
   * Url to image
   */
  image: PropTypes.string,
  /**
   * Placeholder text when no Node is dropped
   */
  placeHolder: PropTypes.string,
  /**
   * Feedback message
   */
  feedbackMessage: PropTypes.string,
  /**
   * Is the Option placed correct or incorrect
   */
  isCorrect: PropTypes.bool,
  /**
   * Function to trigger remove option from step action when wrongly dropped
   * Triggered on click of Incorrect-Icon
   */
  onRemove: PropTypes.func,
  /**
   * Function to trigger add as next step action ( when used as option )
   * Triggered on click of MoveIcon
   */
  onSelect: PropTypes.func,
  /**
   * Is the Step Empty
   */
  isEmpty: PropTypes.bool.isRequired,
  /**
   * Function involked when an option is dropped
   * on EmptyNodeHolder
   */
  onDrop: PropTypes.func,
};

Technique.defaultProps = {
  onRemove: undefined,
  onSelect: undefined,
};
